export default function LoadingSpinner({ className = '' }: { className?: string }) {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="w-8 h-8 border-3 border-gray-300 dark:border-gray-600 border-t-practice dark:border-t-practice-light rounded-full animate-spin" />
    </div>
  );
}
